module.exports = __webpack_public_path__ + "static/media/01_hero_mobile.77c43f2e.jpg";